import { home_index } from "@/api/home";

import { ADD_HOME_INDEX, APP_IS_DOWNLOAD_OR_NOT } from "@/store/mutation_types";

const home = {
  state: {
    homeData: {},
    appLoad: false
  },
  getters: {
    appLoad: state => state.appLoad
  },
  mutations: {
    [ADD_HOME_INDEX]: (state, playload) => {
      const { homeData } = playload;
      state.homeData = homeData;
    },
    [APP_IS_DOWNLOAD_OR_NOT]: (state, data) => {
      state.appLoad = data;
    }
  },
  actions: {
    async home_index({ commit }, playload) {
      const blRes = await home_index(playload);
      const {
        data: { data = {} }
      } = blRes;
      commit(ADD_HOME_INDEX, data);
      return blRes;
    }
  }
};

export default home;
